// extracted by mini-css-extract-plugin
export default {"child-border-override":"search-box_child-border-override__AbzKx"};